/**
 * Created by khanhduong on 11/7/17.
 */

import * as types from '../constants/actionTypes';
import initialState from './initialState';
import * as utils from '../functions/utils';

import {DEFAULT_AGE, DEFAULT_HEIGHT} from '../constants/constants';
import {CATEGORY_ID, CATEGORY_NUMBER} from '../constants/category';
import Immutable from 'seamless-immutable';
import {MEMBER_TYPES_REGISTER} from "../constants/memberTypesRegister";
import moment from "moment";

const defaultUser = initialState.userRegister;
export default function registerReducer(state = initialState.userRegister, action) {
    switch (action.type) {
        case types.GET_DETAILS_PLACE_SUCCESS: {
            state = state.merge({
                ...state,
                location: action.data,
                allowcurrentLocation: action.allowcurrentLocation,
            });
            return state;
        }
        case types.FACE_BOOK_GET_USER_INFO_SUCCESS: {
            const userRegister = state.userRegister.asMutable();
            userRegister.fbInfo = action.data;
            state = state.setIn(['userRegister'], userRegister);
            return state;
        }
        case types.FACE_BOOK_LOGIN_SUCCESS: {
            const userRegister = state.userRegister.asMutable();
            userRegister.fbInfo = action.data;
            userRegister.appleInfo = null
            state = state.setIn(['userRegister'], userRegister);
            return state;
        }
        case types.APPLE_LOGIN_SUCCESS: {
            const userRegister = state.userRegister.asMutable();
            userRegister.appleInfo = action.data;
            userRegister.fbInfo = null;
            state = state.setIn(['userRegister'], userRegister);
            return state;
        }
        case types.GOOGLE_LOGIN_SUCCESS: {
            const userRegister = state.userRegister.asMutable();
            userRegister.googleInfo = action.data;
            state = state.setIn(['userRegister'], userRegister);
            return state;
        }
        case types.REGISTER_SUCCESS: {
            const userRegister = state.userRegister.asMutable();
            userRegister.userRegister = {
                location: null,
                fbInfo: null,
                fbLoginInfo: null,
                appleInfo: null,
                googleInfo: null,
            };
            state = state.setIn(['userRegister'], userRegister);
            return state;
        }

        case types.LTM_LOAD_LOOKING_FOR_SUCCESS: {
            // let data = action.data;
            // state = state.set(CATEGORY_ID.LTM_LOOKING_FOR, data);
            const {
                data: {items, init},
            } = action;

            state = state.set(CATEGORY_ID.LTM_LOOKING_FOR, Object.assign({}, state.lookingFor, init));
            state = state.setIn([CATEGORY_ID.LTM_LOOKING_FOR, 'contentTabs', 0, 'data'], items);
            return state;
        }
        case types.LTM_LOAD_AGE_RANGE_SUCCESS: {
            const {
                data: {items, init},
            } = action;
            state = state.set(CATEGORY_ID.LTM_AGE_RANGE, Object.assign({}, state.ageRange, init));
            state = state.setIn([CATEGORY_ID.LTM_AGE_RANGE, 'contentTabs', 0, 'data'], items);

            let newCategory = state[CATEGORY_ID.LTM_AGE_RANGE];
            newCategory = utils.updateLabelOfCategory(newCategory);
            newCategory.subTabs = utils.setSubTabTitle(newCategory);

            state = state.setIn([CATEGORY_ID.LTM_AGE_RANGE], newCategory);

            return state;
        }
        case types.LTM_LOAD_INTENTIONS_SUCCESS: {
            // let data = action.data;
            // state = state.set(CATEGORY_ID.LTM_INTENTIONS, data);
            const {
                data: {items, init},
            } = action;

            state = state.set(CATEGORY_ID.LTM_INTENTIONS, Object.assign({}, state.intentions, init));
            state = state.setIn([CATEGORY_ID.LTM_INTENTIONS, 'contentTabs', 0, 'data'], items);
            return state;
        }
        case types.TU1_LOAD_SEX_SUCCESS: {
            const {data} = action;
            const {items, init} = data;
            state = state.set(CATEGORY_ID.TU1_SEX, Object.assign({}, state.sex, init));
            state = state.setIn([CATEGORY_ID.TU1_SEX, 'contentTabs', 0, 'data'], items);
            return state;
        }
        case types.TU1_LOAD_AGE_SUCCESS: {
            // let data = {};
            // data = new categoryModel();
            // data = Object.assign(data, action.data);
            // let tab = new categoryTabModel();
            // tab.data.push(Object.assign(new properyItemModel(), {value: new Date()}));
            // data.contentTabs.push(tab);
            const newAge = Object.assign({}, state.age);
            state = state.set(CATEGORY_ID.TU1_AGE, Object.assign(newAge, action.data));
            state = state.setIn([CATEGORY_ID.TU1_AGE, 'contentTabs', 0, 'data', 0, 'value'], utils.setDefaultAge(DEFAULT_AGE));
            return state;
        }
        case types.TU1_LOAD_ETHNICITY_SUCCESS: {
            // let data = action.data;
            // data.singleSelect = true;
            // state = state.set(CATEGORY_ID.TU1_ETHNICITY, data);

            const {
                data: {items, init},
            } = action;
            state = state.set(CATEGORY_ID.TU1_ETHNICITY, Object.assign({}, state.ethnicity, init));
            state = state.setIn([CATEGORY_ID.TU1_ETHNICITY, 'contentTabs', 0, 'data'], items);
            return state;
        }
        case types.UPDATE_MEMBER_TYPE_SUCCESS: {
            const {data} = action;
            state = state.set('memberType', data);
            return state;
        }

        // TELL US ABOUT YOURSELF 2
        case types.LOAD_BODY_TYPES_DATA_SUCCESS: {
            const {
                data: {items, init},
            } = action;
            state = state.set(CATEGORY_ID.TU2_BODY_TYPE, Object.assign({}, state.bodyTypes, init));
            const {contentTabs} = state[CATEGORY_ID.TU2_BODY_TYPE];
            for (let i = 0; i < contentTabs.length; i++) {
                state = state.setIn([CATEGORY_ID.TU2_BODY_TYPE, 'contentTabs', i, 'data'], items);
            }
            return state;
        }
        case types.LOAD_HEIGHT_DATA_SUCCESS: {
            const {
                data: {items, init},
            } = action;
            // Set default height
            if (items && items.length) {
                items.forEach(item => {
                    item.active = item.id === DEFAULT_HEIGHT;
                });
            }

            state = state.set(CATEGORY_ID.TU2_HEIGHT, Object.assign({}, state.height, init));
            const {contentTabs} = state[CATEGORY_ID.TU2_HEIGHT];
            for (let i = 0; i < contentTabs.length; i++) {
                state = state.setIn([CATEGORY_ID.TU2_HEIGHT, 'contentTabs', i, 'data'], items);
            }

            let newCategory = state[CATEGORY_ID.TU2_HEIGHT];
            newCategory = utils.updateLabelOfCategory(newCategory);
            newCategory.subTabs = utils.setSubTabTitle(newCategory);

            state = state.setIn([CATEGORY_ID.TU2_HEIGHT], newCategory);

            return state;
        }
        case types.LOAD_ORIENTATION_DATA_SUCCESS: {
            // let data = action.data;
            // data.singleSelect = true;
            // state = state.set(CATEGORY_ID.TU2_ORIENTATION, data);
            const {
                data: {items, init},
            } = action;
            state = state.set(CATEGORY_ID.TU2_ORIENTATION, Object.assign({}, state.orientation, init));
            const {contentTabs} = state[CATEGORY_ID.TU2_ORIENTATION];
            for (let i = 0; i < contentTabs.length; i++) {
                state = state.setIn([CATEGORY_ID.TU2_ORIENTATION, 'contentTabs', i, 'data'], items);
            }
            return state;
        }

        case types.LOAD_INTRODUCE_YOURSELF_SUCCESS: {
            const {data} = action;
            state = state.set('aboutYou', Object.assign({}, state.aboutYou, data.aboutYouParams));
            return state.set('yourIdealMatch', Object.assign({}, state.yourIdealMatch, data.yourIdealMatchParams));
        }
        case types.LOAD_PERSONALITY_DATA_SUCCESS: {
            const {data} = action;
            state = state.set('personality', Object.assign({}, state.personality, data.init));
            return state.setIn(['personality', 'contentTabs', '0', 'data'], data.items);
        }
        case types.LOAD_LOOK_DATA_SUCCESS: {
            const {data} = action;
            state = state.set('looks', Object.assign({}, state.looks, data.init));
            return state.setIn(['looks', 'contentTabs', '0', 'data'], data.items);

            // return state.set('looks', data);
        }
        case types.LOAD_INTERESTS_DATA_SUCCESS: {
            const {data} = action;
            state = state.set('interests', Object.assign({}, state.interests, data.init));
            return state.setIn(['interests', 'contentTabs', '0', 'data'], data.items);
            // return state.set('interests', data);
        }
        case types.LOAD_MPB_LOOKING_FOR_DATA_SUCCESS: {
            const {data} = action;
            state = state.set('mpbLookingFors', Object.assign({}, state.mpbLookingFors, data.init));
            return state.setIn(['mpbLookingFors', 'contentTabs', '0', 'data'], data.items);
            // return state.set('mpbLookingFors', data);
        }

        case types.SELECT_PROPERTY_ITEM_SUCCESS: {
            const {data} = action;
            const category = data.idCategory;
            const {indexTab} = data;
            const selectingCategory = state[category];
            let numberItemSelected = 0;
            let valueSingleNotChange = false;
            const updatePropertyItems = selectingCategory.contentTabs[indexTab].data.map(value => {
                if (value.id === data.id && value.listId === data.listId) {
                    const updatedValue = Object.assign({}, value);
                    if (!selectingCategory.singleSelect) {
                        updatedValue.active = !value.active;
                    } else {
                        if (!value.active) {
                            updatedValue.active = !value.active;
                        } else {
                            valueSingleNotChange = true;
                        }
                    }
                    return updatedValue;
                }
                if (selectingCategory.singleSelect) {
                    const updatedValue = Object.assign({}, value);
                    updatedValue.active = false;
                    return updatedValue;
                }

                return value;
            });

            state = state.setIn([category, 'contentTabs', indexTab, 'data'], updatePropertyItems);
            if (valueSingleNotChange) {
                return state;
            }

            // Note : Danh add this condition to update label bottom of category and isSelected state when press item. Use it data for back case
            updatePropertyItems.forEach(item => {
                if (item.active) {
                    numberItemSelected++;
                }
            });
            if (numberItemSelected > 0) {
                // todo Danh note need to check this logic again
                // state = state.setIn([category, "labelBottom", "value"], numberItemSelected);
                // state = state.setIn([category, "isSelected"], true);
                if (selectingCategory.singleSelect) {
                    state = state.setIn([category, 'onNext'], !state[category].onNext);
                }
            } else {
                state = state.setIn([category, 'labelBottom', 'value'], '');
                // state = state.setIn([category, "isSelected"], false);
                if (state[category].subTabs.length === 2) {
                    state = state.setIn([category, 'subTabs', indexTab, 'isSelected'], false);
                }
            }

            if (!utils.checkCategoryHasValue(state[category])) {
                state = state.setIn([category, 'isSelected'], false);
            }

            // updateLabelCategory
            let newCategory = Immutable.asMutable(state[category]);
            newCategory = utils.updateLabelOfCategory(newCategory);
            newCategory.subTabs = utils.setSubTabTitle(newCategory);

            state = state.setIn([category], newCategory);

            // myStore.getStore().dispatch(conversationInboxAction.updateUnreadAndLastMessage(_message));

            return state;
        }
        case types.UPDATE_CATEGORY_SUCCESS: {
            const {data} = action;
            if (data && Object.keys(data).length) {
                Object.keys(data).forEach(item => {
                    state = state.set(item, data[item]);
                });
            }
            return state;
        }

        case types.UPDATE_SELECTING_CATEGORY_SUCCESS: {
            const {data} = action;
            state = state.set('selectingCategoryId', data);
            state = state.setIn([data, 'isSelecting'], true);
            return state;
        }

        case types.UPDATE_AGE_RANGE: {
            const {data} = action;
            state = state.setIn(['ageRange', 'contentTabs', 0, 'data', 0, 'value'], data.min);
            state = state.setIn(['ageRange', 'contentTabs', 0, 'data', 1, 'value'], data.max);

            let newCategory = Immutable.asMutable(state[CATEGORY_ID.LTM_AGE_RANGE]);
            newCategory = utils.updateLabelOfCategory(newCategory);
            state = state.setIn([CATEGORY_ID.LTM_AGE_RANGE], newCategory);
            return state;
        }

        case types.UPDATE_STATUS_LOAD_MORE_PROPERTY_ITEMS_SUCCESS: {
            const {data} = action;
            const category = data.selectingCategoryId;
            state = state.setIn([category, 'isMore'], false);
            return state;
        }

        case types.UPDATE_ACTION_CHANGE_CATEGORY_SUCCESS: {
            const {data} = action;
            const {categories} = data;
            const indexSelecting = categories.findIndex(e => e.isSelecting);
            for (let i = categories.length - 1; i >= 0; i--) {
                if ((categories[i].isSelected && categories[i].id === data.id) || (categories[i].isSkip && categories[i].id === data.id)) {
                    state = state.set('selectingCategoryId', data.id);
                    state = state.setIn([data.id, 'isSelecting'], true);
                    state = state.setIn([categories[indexSelecting].id, 'isSelecting'], false);
                    if (CATEGORY_NUMBER[data.id] > CATEGORY_NUMBER[categories[indexSelecting].id]) {
                        if (utils.checkCanNext(categories[indexSelecting], categories[indexSelecting].indexTab)) {
                            state = state.setIn([categories[indexSelecting].id, 'isSelected'], true);
                        }
                    }
                }
            }
            return state;
        }

        // case types.USER_LOGIN_ACCOUNT_SUCCESS: {
        //         // console.log('action',action.data);
        //       let userRegister = state.userRegister.asMutable() ;
        //       userRegister.fbInfo = action.data;
        //       state = state.setIn(['userRegister'], userRegister);
        //       return state;
        //     }

        // case types.FACE_BOOK_LOGIN_SUCCESS: {
        //     // console.log('action',action.data);
        //   return state;
        // }

        case types.TU3_LOAD_GENERAL_SUCCESS: {
            const {
                data: {items, init},
            } = action;
            state = state.set(CATEGORY_ID.WYI_GENERAL, Object.assign({}, state.general, init));
            state = state.setIn([CATEGORY_ID.WYI_GENERAL, 'contentTabs', 0, 'data'], items);
            return state;
        }

        case types.TU3_LOAD_SEXUAL_SIGNLE_SUCCESS: {
            const {
                data: {items, init},
            } = action;
            state = state.set(CATEGORY_ID.WYI_SEXUAL, Object.assign({}, state.sexual, init));
            state = state.setIn([CATEGORY_ID.WYI_SEXUAL_SIGNLE, 'contentTabs', 0, 'data'], items);
            return state;
        }
        case types.TU3_LOAD_SEXUAL_COUPLE_SUCCESS: {
            const {
                data: {items, init},
            } = action;
            state = state.set(CATEGORY_ID.WYI_SEXUAL, Object.assign({}, state.sexual, init));
            state = state.setIn([CATEGORY_ID.WYI_SEXUAL_COUPLE, 'contentTabs', 0, 'data'], items);
            return state;
        }
        case types.TU3_LOAD_FETISH_SUCCESS: {
            // let data = action.data;
            // state = state.set('fetish', data);

            const {
                data: {items, init},
            } = action;
            state = state.set(CATEGORY_ID.WYI_FETISH, Object.assign({}, state.fetish, init));
            state = state.setIn([CATEGORY_ID.WYI_FETISH, 'contentTabs', 0, 'data'], items);

            return state;
        }

        case types.UPDATE_SELECTING_PROFILE_BUILDER_ITEM_SUCCESS: {
            const {data} = action;
            const selectingCategory = state[data.selectingCategoryId];
            const updatePropertyItems = selectingCategory.contentTabs[0].data.map(value => {
                if (value.id === data.id) {
                    const updatedValue = Object.assign({}, value);
                    updatedValue.active = !value.active;
                    return updatedValue;
                }
                const updatedValue = Object.assign({}, value);
                updatedValue.active = false;
                return updatedValue;
            });

            state = state.setIn([data.selectingCategoryId, 'contentTabs', 0, 'data'], updatePropertyItems);
            // state = state.setIn([selectingCategory.id, "onNext"], state[selectingCategory.id].onNext ? false : true);

            return state;
        }

        case types.UPDATE_INDEX_TAB: {
            const {data} = action;
            state = state.setIn([data.selectingCategoryId, 'indexTab'], data.indexTab);
            return state;
        }

        case types.UPDATE_SUB_TAB_SUCCESS: {
            const {data} = action;
            state = state.setIn([data.selectingCategoryId, 'subTabs', data.indexTab, 'isSelected'], true);
            return state;
        }

        case types.UPDATE_MEMBER_TYPE: {
            state = state.set('memberType', action.data.memberType);
            return state;
        }

        case types.TU1_UPDATE_AGE_SUCCESS: {
            const {data} = action;
            state = state.setIn([CATEGORY_ID.TU1_AGE, 'contentTabs', data.indexTab, 'data', '0', 'value'], data.value);
            let newCategory = state[CATEGORY_ID.TU1_AGE];
            newCategory = utils.updateLabelOfCategory(newCategory);
            newCategory.subTabs = utils.setSubTabTitle(newCategory);
            state = state.set(CATEGORY_ID.TU1_AGE, newCategory);
            return state;
        }
        case types.TU1_UPDATE_HEIGHT_SUCCESS: {
            const {data} = action;
            const value = data.value || {};
            const {selectingCategoryId, indexTab} = data;
            const selectingCategory = state[selectingCategoryId];
            const items = selectingCategory.contentTabs[indexTab].data;
            items.forEach((item, index) => {
                state = state.setIn([CATEGORY_ID.TU2_HEIGHT, 'contentTabs', indexTab, 'data', index, 'active'], item.id === value.id);
            });

            let newCategory = state[CATEGORY_ID.TU2_HEIGHT];
            newCategory = utils.updateLabelOfCategory(newCategory);
            newCategory.subTabs = utils.setSubTabTitle(newCategory);
            state = state.set(CATEGORY_ID.TU2_HEIGHT, newCategory);

            return state;
        }

        case types.UPDATE_VALUE_SUCCESS: {
            const {data} = action;
            // state = state.setIn([data.selectingCategoryId, "isSelected"], true);
            state = state.setIn([data.selectingCategoryId, 'contentTabs', data.indexTab, 'data', '0', 'value'], data.value);
            return state;
        }

        case types.RESET_PASSWORD_SUCCESS: {
            state = state.set('isResetPassword', true);
            return state;
        }

        case types.UPDATE_CAN_NEXT_CATEGORY_SUCCESS: {
            state = state.set('canNextCategory', action.data);
            return state;
        }

        case types.UPDATE_CURRENT_LOCATION_SUCCESS: {
            // /   console.log(action)
            return state.merge({...state, currentLocation: action.data});
        }

        case types.UPDATE_STATE_LOADING_GET_CURRENT_POSITION_SUCCESS: {
            return state.merge({...state, loadingGetCurrentPosition: action.data});
        }
        case types.UPDATE_USER_REGISTER_PROPERTY_STATE: {
            return state.set([...action.data.dataKey], action.data.dataValue);
        }
        case types.MERGE_USER_REGISTER_PROPERTY_STATE: {
            return state.merge({
                ...state,
                [action.data.dataKey]: action.data.dataValue,
            });
        }
        case types.ADD_REGISTRATION_PROPERTY_STATE: {
            // console.log(action.data)
            let key = {};
            let updateObject = null;
            let removeFromArray = null;
            let index = null;
            const addOrDelete = (data, category, type, onlyRemove = false) => {
                key = [category];
                if (type) {
                    if (data.includes(action.data.id)) {
                        removeFromArray = [...data];
                        index = removeFromArray.indexOf(action.data.id);
                        removeFromArray.splice(index, 1);
                        updateObject = removeFromArray;
                    } else {
                        if (!onlyRemove) {
                            updateObject = data.concat(action.data.id);
                        }
                    }
                } else {
                    if (data !== action.data.id) {
                        updateObject = action.data.id;
                    } else {
                        updateObject = null;
                    }
                }
                return state.setIn([...key], updateObject);
            };
            if (action.data.type) {
                // true multiple false single
                // lookingfor, intentions, general, sexual, fetish
                switch (action.data.category) {
                    case CATEGORY_ID.LTM_LOOKING_FOR:
                        return addOrDelete(state.seekingTypesMultiSelectArray, 'seekingTypesMultiSelectArray', true);
                    case CATEGORY_ID.LTM_INTENTIONS:
                        let updateObject = {};
                        const remove = (data, key) => {
                            const removeFromArray = [...data];
                            index = removeFromArray.indexOf(action.data.id);
                            removeFromArray.splice(index, 1);
                            updateObject = {
                                ...updateObject,
                                [key]: removeFromArray,
                            };
                        };
                        if (state.dealBreakerMultiSelectArray.includes(action.data.id)) {
                            remove(state.dealBreakerMultiSelectArray, 'dealBreakerMultiSelectArray');
                        }
                        if (state.intentionMultiSelectArray.includes(action.data.id)) {
                            remove(state.intentionMultiSelectArray, 'intentionMultiSelectArray');
                        } else {
                            const d = state.intentionMultiSelectArray;
                            updateObject = {
                                ...updateObject,
                                intentionMultiSelectArray: d.concat(action.data.id),
                            };
                        }
                        return state.merge({...updateObject});
                    case CATEGORY_ID.WYI_GENERAL:
                        return addOrDelete(state.generalInterestMultiSelectArray, 'generalInterestMultiSelectArray', true);
                    case CATEGORY_ID.WYI_SEXUAL_SIGNLE:
                        return addOrDelete(state.sexualInterestMultiSelectArray, 'sexualInterestMultiSelectArray', true);
                    case CATEGORY_ID.WYI_SEXUAL_COUPLE:
                        return addOrDelete(state.sexualInterestMultiSelectArray, 'sexualInterestMultiSelectArray', true);
                    case CATEGORY_ID.WYI_FETISH:
                        return addOrDelete(state.fetishInterestMultiSelectArray, 'fetishInterestMultiSelectArray', true);
                    case CATEGORY_ID.LTM_DEAL_BREAKER:
                        return addOrDelete(state.dealBreakerMultiSelectArray, 'dealBreakerMultiSelectArray', true);
                    default:
                        return state;
                }
            } else {
                // ageRange, imweare, age, ethnity, bodytype, height, orientation
                switch (action.data.category) {
                    case CATEGORY_ID.LTM_AGE_RANGE:
                        key = 'userProfileDetailInfo';
                        updateObject = {
                            ...state.userProfileDetailInfo,
                            SeekingYoungest: action.data.id[0],
                            SeekingOldest: action.data.id[1],
                        };
                        break;
                    case CATEGORY_ID.TU1_SEX:
                        key = 'memberType';
                        updateObject = state.memberType !== action.data.id ? action.data.id : 0;
                        break;
                    case CATEGORY_ID.TU1_AGE:
                        key = 'userProfileDetailInfo';
                        if (action.data.time === 1) {
                            const isWomen = state.memberType === MEMBER_TYPES_REGISTER.WOMEN
                            const defaultAge = moment().diff(action.data.id, 'years')
                            updateObject = {
                                ...state.userProfileDetailInfo,
                                Birthdate: action.data.id,
                                SeekingYoungest: isWomen ? defaultAge - 10 : 18,
                                SeekingOldest: isWomen ? defaultAge + 20 : 65
                            }
                        } else {
                            updateObject = {
                                ...state.userProfileDetailInfo,
                                Birthdate2: action.data.id,
                            };
                        }
                        break;
                    case CATEGORY_ID.TU1_ETHNICITY:
                        key = 'userProfileDetailInfo';
                        if (action.data.time === 1) {
                            updateObject = {
                                ...state.userProfileDetailInfo,
                                Race: state.userProfileDetailInfo.Race !== action.data.id ? action.data.id : null,
                            };
                        } else {
                            updateObject = {
                                ...state.userProfileDetailInfo,
                                Race2: state.userProfileDetailInfo.Race2 !== action.data.id ? action.data.id : null,
                            };
                        }
                        break;
                    case CATEGORY_ID.TU2_BODY_TYPE:
                        key = 'userProfileDetailInfo';
                        if (action.data.time === 1) {
                            updateObject = {
                                ...state.userProfileDetailInfo,
                                BodyType: state.userProfileDetailInfo.BodyType !== action.data.id ? action.data.id : null,
                            };
                        } else {
                            updateObject = {
                                ...state.userProfileDetailInfo,
                                BodyType2: state.userProfileDetailInfo.BodyType2 !== action.data.id ? action.data.id : null,
                            };
                        }
                        break;
                    case CATEGORY_ID.TU2_HEIGHT:
                        key = 'userProfileDetailInfo';

                        if (action.data.time === 1) {
                            updateObject = {
                                ...state.userProfileDetailInfo,
                                Height: action.data.id,
                                HeightItemId: action.data ? action.data.id : undefined,
                            };
                        } else {
                            updateObject = {
                                ...state.userProfileDetailInfo,
                                Height2: action.data.id,
                                Height2ItemId: action.data ? action.data.id : undefined,
                            };
                        }
                        break;
                    case CATEGORY_ID.TU2_ORIENTATION:
                        key = 'userProfileDetailInfo';
                        if (action.data.time === 1) {
                            updateObject = {
                                ...state.userProfileDetailInfo,
                                SexualOrientation: state.userProfileDetailInfo.SexualOrientation !== action.data.id ? action.data.id : null,
                            };
                        } else {
                            updateObject = {
                                ...state.userProfileDetailInfo,
                                SexualOrientation2: state.userProfileDetailInfo.SexualOrientation2 !== action.data.id ? action.data.id : null,
                            };
                        }
                        break;
                    case CATEGORY_ID.INTRO_BODY:
                        key = 'userProfileDetailInfo';
                        updateObject = {
                            ...state.userProfileDetailInfo,
                            IntroBody: action.data.id,
                        };
                        break;
                    case CATEGORY_ID.LOCATION:
                        key = 'location';
                        updateObject = action.data.id;
                        break;
                    case CATEGORY_ID.RELATION_SHIP:
                        key = 'userProfileDetailInfo';
                        updateObject = {
                            ...state.userProfileDetailInfo,
                            MaritalStatus: state.userProfileDetailInfo.MaritalStatus !== action.data.id ? action.data.id : null,
                            MaritalStatus2: state.userProfileDetailInfo.MaritalStatus2 !== action.data.id ? action.data.id : null,
                        };

                        break;
                    default:
                        return state;
                }
                return state.merge({...state, [key]: updateObject});
            }
        }
        case types.CALC_USER_REGISTER_PROPERTY_STATE: {
            const seekingTypesCalculatedInt = state.seekingTypesMultiSelectArray.reduce((a, b) => a + b, 0);
            const intentionCalculatedInt = state.intentionMultiSelectArray.reduce((a, b) => a + b, 0);
            const generalInterestCalculatedInt = state.generalInterestMultiSelectArray.reduce((a, b) => a + b, 0);
            const fetishInterestCalculatedInt = state.fetishInterestMultiSelectArray.reduce((a, b) => a + b, 0);
            const selectedSexualInterestsAsIntegers = [];
            const selectedSexualPreferenceAsIntegers = [];
            const selectedSexualInterestsAsStrings = state.sexualInterestMultiSelectArray;
            selectedSexualInterestsAsStrings.forEach(item => {
                const selectionWithHashRemovedFirst = item.substr(0, item.lastIndexOf('#'));
                const selectionWithHashRemovedSecond = item.substr(item.indexOf('#') + 1, item.length);
                switch (parseInt(selectionWithHashRemovedSecond)) {
                    case 70: {
                        selectedSexualPreferenceAsIntegers.push(parseInt(selectionWithHashRemovedFirst));
                        break;
                    }
                    case 71:
                    case 72: {
                        selectedSexualInterestsAsIntegers.push(parseInt(selectionWithHashRemovedFirst));
                        break;
                    }
                    default:
                        break;
                }
            });
            const sexualInterestCalculatedInt = selectedSexualInterestsAsIntegers.reduce((a, b) => a + b, 0);
            const sexualPreferenceCalculatedInt = selectedSexualPreferenceAsIntegers.reduce((a, b) => a + b, 0);
            return state.merge({
                ...state,
                userProfileDetailInfo: {
                    ...state.userProfileDetailInfo,
                    SeekingTypes: seekingTypesCalculatedInt,
                    FetishInterest: fetishInterestCalculatedInt,
                    GeneralInterest: generalInterestCalculatedInt,
                    SexualInterest: sexualInterestCalculatedInt,
                    SexualPreference: sexualPreferenceCalculatedInt,
                    Intention: intentionCalculatedInt,
                },
            });
        }
        case types.UPDATE_USER_DETAIL_LOCATION: {
            state = state.setIn(['location'], action.data);
            return state;
        }
        case types.RESET_STATE_USER_REGISTER: {
            return state.merge({
                ...defaultUser,
                allowcurrentLocation: state.allowcurrentLocation,
                location: state.location,
            });
        }
        case types.USER_LOGOUT_SUCCESS: {
            state = initialState.userRegister;
            return state;
        }
        case types.TU1_LOAD_RELATION_SHIP_SUCCESS: {
            // let data = action.data;
            // data.singleSelect = true;
            // state = state.set(CATEGORY_ID.TU1_ETHNICITY, data);

            const {
                data: {items, init},
            } = action;
            state = state.set(CATEGORY_ID.RELATION_SHIP, Object.assign({}, state.relationship, init));
            state = state.setIn([CATEGORY_ID.RELATION_SHIP, 'contentTabs', 0, 'data'], items);
            return state;
        }
        default:
            return state;
    }
}
